import elementRegistry from './registry';

const ElementRenderer = ({ element }) => {
    const Component = elementRegistry[element.type];

    if (!Component) {
        return null;
    }

    return <Component element={element} />;
};

export default ElementRenderer;
